import { createSelector } from '@reduxjs/toolkit';

import { userApi } from './apis/userApi';
import type { RoleProps } from '../models';

const selectRolsResult = userApi.endpoints.getRoles.select();

// see https://redux.js.org/usage/deriving-data-selectors#createselector-overview
// for how create Selector works
export const selectSupplierRoleId = createSelector(selectRolsResult, (data) => {
	if (!data.data) {
		return undefined;
	}

	const roles: RoleProps[] = data.data;

	const role = roles.find((role) => role.role === 'SUPPLIER');

	return role?.id;
});
